export function isHtml(input: string): boolean {
  if (!input) {
    return false
  }
  return input.trim().startsWith('<') && input.trim().endsWith('>')
}
